import { useMutation } from 'react-query';
import { regenerateScene } from '../../services/sceneService';

export const useRegenerateScene = () => {
  return useMutation((sceneId: string) => regenerateScene(sceneId));
};
